/**
 * get line-height prop of element (in px)
 *
 * @param {HTMLElement} element HTML элемент
 *
 * @return {string}
 *
 * @example camelToSnake('myArg') => 'my_arg';
 */
import { getNodeStyle } from './getNodeStyle';

export const getLineHeight = (element: HTMLElement) => {
	let lineHeight = parseInt(getNodeStyle(element, 'line-height'), 10);
	let singleLineHeight;
	let doubleLineHeight;

	if (isNaN(lineHeight)) {
		const clonedNode = element.cloneNode() as HTMLElement;

		clonedNode.innerHTML = '<br>';
		element.appendChild(clonedNode);
		singleLineHeight = clonedNode.offsetHeight;
		clonedNode.innerHTML = '<br><br>';
		doubleLineHeight = clonedNode.offsetHeight;
		element.removeChild(clonedNode);
		lineHeight = doubleLineHeight - singleLineHeight;
	}

	return lineHeight;
};
